<template>
    <transition name="slide-fade" mode="out-in">
        <div class="wrapper-right text-h5" :key="valueFormat">
          {{ valueFormat }}
        </div>
      </transition>
</template>

<script>
    export default {
        props: ['qty', 'value'],
        data() {
            return {
                valueFormat: this.value
            }
        },
        watch: {
            value: function (val) {
                this.valueFormat = new Intl.NumberFormat('nl-NL', {
                    style: 'currency',
                    currency: 'EUR'
                }).format(val);
            }
        },
        mounted() {
            this.valueFormat = new Intl.NumberFormat('nl-NL', {
                style: 'currency',
                currency: 'EUR'
            }).format(this.value);
        }
    }
</script>

<style scoped>
    div.wrapper-right {
        font-weight: 700;
        flex-basis: 40%;
    }
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter,
    .slide-fade-leave-to {
        transform: translateX(10px);
        opacity: 0;
    }
</style>
